import { useYTSFaucet } from './useContract'
import { useTransactionAdder } from '../state/transactions/hooks'
import { useCallback } from 'react'
import { calculateGasMargin } from '../utils'
import { TransactionResponse } from '@ethersproject/providers'
import { useSingleCallResult } from '../state/multicall/hooks'
import { JSBI } from '@yetiswap/sdk'

export function useFaucetClaim(nounce: string) {
  const contract = useYTSFaucet()
  const addTransaction = useTransactionAdder()

  const claim = useCallback(async (): Promise<void> => {
    if (!contract) return
    const args: any[] = [nounce]
    return await contract.estimateGas['AAAXABCSAACEDAS'](...args, {}).then(estimatedGasLimit => {
      return contract
        .AAAXABCSAACEDAS(...args, { value: null, gasLimit: calculateGasMargin(estimatedGasLimit) })
        .then((response: TransactionResponse) => {
          return response
            .wait(1)
            .then(() => {
              addTransaction(response, {
                summary: 'YTS Claim Successfully'
              })
            })
            .catch((ex: any) => console.log(ex))
        })
    })
  }, [addTransaction, contract, nounce])

  return [claim]
}

export function useClaimStatus(account: string) {
  const contract = useYTSFaucet()
  const claimStatus = useSingleCallResult(contract, 'claimStatus', [account])
  let result = '1'

  if (!claimStatus.loading && claimStatus.result && claimStatus.result[0]) {
    result = JSBI.BigInt(claimStatus.result[0]).toString()
  }
  return result
}

export function useGetNounce() {
  const contract = useYTSFaucet()
  const getNounce = useSingleCallResult(contract, 'getNounce', [])
  let result = ''

  if (!getNounce.loading && getNounce.result && getNounce.result[0]) {
    result = JSBI.BigInt(getNounce.result[0]).toString()
  }
  return result
}
